export default __webpack_public_path__ + "static/media/8a061f5f00e35ab5.75afdf3655f8486eb236f67a8edb1589.svg";